import Image from 'next/image'

/* blocks */
import BlogNewsletterForm from '@/molecules/Forms/BlogNewsletterForm/BlogNewsletterForm'

type Props = {
  title: string
  description?: string
  bgColor: string
  isAside?: boolean
}

function BlogNewsletter({
  title,
  description,
  bgColor,
  isAside = false
}: Props) {
  return (
    <section
      className="text-white | rounded-md max-w-xs mx-auto"
      style={{ background: bgColor }}
    >
      <div className="container | py-9">
        <div className="font-heading justify-center items-center | grid grid-cols-1 gap-14">
          <div className="md:text-left">
            <h2
              className="text-2xl font-semibold | tracking-tight | mb-4"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            {description ? (
              <div
                className="text-base | pb-7 md:pb-9"
                dangerouslySetInnerHTML={{ __html: description }}
              ></div>
            ) : null}
            <BlogNewsletterForm isAside={isAside} />
          </div>
          <div className="mx-auto relative">
            <Image
              src="/assets/blog/newsletter.svg"
              alt=""
              width={476}
              height={435}
              className="mx-auto"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlogNewsletter
